import { Injectable } from '@angular/core';
import { Http, RequestOptions, RequestOptionsArgs, Response, Headers, ConnectionBackend } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';

// Shows Progress bar and notifications
import { LoaderEvent } from './message.event';

@Injectable()
export class HttpInterceptor extends Http {
  private vendor;

  constructor(
    private backend: ConnectionBackend,
    private defaultOptions: RequestOptions,
    private loaderEvent: LoaderEvent,
  ) {
    super(backend, defaultOptions);
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }
  }

  /**
   * Performs a request with `get` http method.
   * @param url
   * @param body
   * @param options
   * @returns {Observable<>}
   */
  get(url: string, body?, options?: RequestOptionsArgs): Observable<any> {
    // For external URLs, skip beforeRequest body modification
    const isExternalUrl = url.startsWith('http://') || url.startsWith('https://');

    console.log('HttpInterceptor.get - URL:', url);
    console.log('HttpInterceptor.get - isExternalUrl:', isExternalUrl);
    console.log('HttpInterceptor.get - options:', options);

    if (!isExternalUrl && body) {
      this.beforeRequest(body);
    }

    const finalUrl = this.getFullUrl(url);
    const finalOptions = this.requestOptions(options, isExternalUrl);

    console.log('HttpInterceptor.get - Final URL:', finalUrl);
    console.log('HttpInterceptor.get - Final headers:', finalOptions.headers);

    return super.get(finalUrl, finalOptions)
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        this.onError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `post` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  post(url: string, body: any, options?: RequestOptionsArgs, callback?: any): Observable<any> {
    body = this.beforeRequest(body);
    let requestOptions = this.requestOptions(options);
    return super.post(this.getFullUrl(url), body, requestOptions)
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        callback;
        this.onError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `put` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
    body = this.beforeRequest(body);
    let requestOptions = (body instanceof FormData) ? options : this.requestOptions(options);
    return super.put(this.getFullUrl(url), body, this.requestOptions(options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        this.onError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Performs a request with `delete` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  delete(url: string, body, options?: RequestOptionsArgs): Observable<any> {
    this.beforeRequest(body);
    return super.delete(this.getFullUrl(url), this.requestOptions(options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        this.onError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  /**
   * Request options.
   * @param options
   * @param isExternalUrl - Flag to indicate if this is an external API call
   * @returns {RequestOptionsArgs}
   */
  private requestOptions(options?: RequestOptionsArgs, isExternalUrl?: boolean): RequestOptionsArgs {
    if (options == null) {
      options = new RequestOptions();
    }

    if (options.headers == null) {
      options.headers = new Headers();
    }

    // For external APIs, preserve custom headers and don't add Authorization
    if (isExternalUrl) {
      return options;
    }

    // For internal APIs, add Authorization header
    if (this.vendor) {
      options.headers.set('Authorization', 'Bearer ' + this.vendor.token);
    }

    return options;
  }

  /**
   * Build API url.
   * @param url
   * @returns {string}
   */
  private getFullUrl(url: string): string {
    // If URL starts with http:// or https://, it's an external URL - don't modify it
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // Otherwise, prepend the base URL for internal API calls
    return environment.appBaseUrl + url;
  }

  /**
   * Before any Request.
   */
  private beforeRequest(body): void {
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }
    if (this.vendor) {
      body['systemUserId'] = this.vendor._id;
      body['token'] = this.vendor.token;
    }
    let appVersion = localStorage.getItem('appVersion')
    if (appVersion) {
      body['appVersion'] = appVersion;
    }
    body['deviceId'] = '';
    body['deviceType'] = CONSTANT_VALUES.DEVICE_TYPE;
    body['deviceToken'] = '';
    return body;
  }

  /**
   * After any request.
   */
  private afterRequest(): void {
    // this.loaderEvent.fire(false);
  }

  /**
   * Error handler.
   * @param error
   * @param caught
   * @returns {ErrorObservable}
   */
  private onCatch(error: any, caught: Observable<any>): Observable<any> {
    // this.notifyService.popError();
    return Observable.throw(error);
  }

  /**
   * onSuccess
   * @param res
   */
  private onSuccess(res: Response): void {
  }

  /**
   * onError
   * @param error
   */
  private onError(error: any): void {
    // this.notifyService.popError();
  }

  /**
   * onFinally
   */
  private onFinally(): void {
    this.afterRequest();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/http-interceptor.ts